exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.data-card[data-v-4cbab886] {\n  min-height: 65px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  flex-direction: column;\n}\n.fa-pencil[data-v-4cbab886] {\n  color: #838383;\n}\n.editor[data-v-4cbab886] {\n  padding-top: 1rem;\n}\nbutton[data-v-4cbab886] {\n  cursor: pointer;\n  background: transparent;\n  border: none;\n}\n", ""]);

// exports
